module.exports = __webpack_public_path__ + "img/kernelback1.f1f2f5dc.png";